<template>
    <div class="ticket-section">
        <div class="ticket-content">
            <h2 class="ticket-title fuente-posm">
                Imprimimos un Ticket Inteligente
            </h2>
            <p class="ticket-text fuente-nova">
                Entrega a tus clientes todo lo necesario para facturar desde su primer ticket y descarga a tu equipo de labores repetitivas.
                <br><br>
                Nuestro micrositio se adapta a la imagen de tu marca y te permite definir reglas como fechas límite, tipos de pago permitidos y restricciones según tus políticas internas.
            </p>
        </div>
        <div class="ticket-image">
            <img :src="a75" alt="Ticket inteligente">
        </div>
    </div>
</template>

<script>
export default {
    name: 'TicketInteligenteNew',
    data() {
        return {
            a75: require('@/assets/images/a75.webp')
        }
    }
}
</script>

<style lang="css" scoped>
.ticket-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 60px;
    background-color: #272727;
}

.ticket-content {
    flex: 1;
    max-width: 600px;
}

.ticket-title {
    color: var(--color-5);
    font-size: 70px;
    line-height: 1.1;
    margin: 0 0 20px 0;
}

.ticket-text {
    color: var(--color-5);
    font-size: 29px;
    line-height: 1.3;
    margin: 0;
    padding-left: 10px;
}

.ticket-image {
    flex: 0 0 auto;
    max-width: 500px;
}

.ticket-image img {
    width: 100%;
    height: auto;
    border-radius: 8px;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .ticket-title {
        font-size: 60px;
    }

    .ticket-text {
        font-size: 27px;
    }

    .ticket-image {
        max-width: 400px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .ticket-section {
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        padding: 100px 20px 40px 20px;
        gap: 20px;
    }

    .ticket-content {
        order: 1;
        max-width: 100%;
        flex: none;
    }

    .ticket-image {
        order: 2;
        width: 100%;
        max-width: none;
        flex: 1;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 20px;
    }

    .ticket-image img {
        width: 90%;
        max-width: none;
    }

    .ticket-title {
        font-size: 24px;
        line-height: 1.2;
        margin: 0 0 10px 0;
    }

    .ticket-text {
        font-size: 16px;
        padding-left: 10px;
        margin: 0;
    }
}
</style>
